const statsTypes = {
  RESET_SHORT_LINK_STATE: 'RESET_SHORT_LINK_STATE',
  CREATE_SHORT_LINK: {
    REQUEST: 'CREATE_SHORT_LINK.REQUEST',
    SUCCESS: 'CREATE_SHORT_LINK.SUCCESS',
    FAILURE: 'CREATE_SHORT_LINK.FAILURE',
  },
  FETCH_SHORT_LINKS: {
    REQUEST: 'FETCH_SHORT_LINKS.REQUEST',
    SUCCESS: 'FETCH_SHORT_LINKS.SUCCESS',
    FAILURE: 'FETCH_SHORT_LINKS.FAILURE',
  },
};

export default statsTypes;
